import { render } from "./MisBuzones.vue?vue&type=template&id=507a2ef8&scoped=true"
import script from "./MisBuzones.vue?vue&type=script&lang=js"
export * from "./MisBuzones.vue?vue&type=script&lang=js"

import "./MisBuzones.vue?vue&type=style&index=0&id=507a2ef8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507a2ef8"]])

export default __exports__